import appConfig from "../config.json";
import { loadCdnCssFile } from "./env";
import { mapString, isCurrentPathPresent } from "./common";

const { brands, allowedThemes, themePath } = appConfig;

let bodyMutationObserver;

export const loadCustomThemes = (assetsCdn, brand) => {
	const customThemes = brands[brand].customThemes || [];
	if (customThemes.length) {
		setTimeout(() => {
			for (let index = 0; index < customThemes.length; index++) {
				const themeName = brands[brand].customThemes[index];
				const cssCdnUrl = mapString(themePath, themeName);
				loadCdnCssFile(assetsCdn, cssCdnUrl);
			}
		}, 1000);
	}
};

const findThemeInClassesList = (assetsCdn, brand) => {
	const classes = document.body.classList;
	for (let index = 0; index < allowedThemes.length; index++) {
		if (classes.contains(allowedThemes[index])) {
			const cssCdnUrl = mapString(themePath, allowedThemes[index]);
			loadCdnCssFile(assetsCdn, cssCdnUrl);
			return true;
		}
	}
	return false;
};

export const validateIfThemeShouldBeLoaded = (themes, brand) => {
	if (themes) {
		for (const theme in themes) {
			if (themes[theme].allowedPagesToApplyThemes) {
				const preventAddClassToBody = brands[
					brand
				]?.preventAddClassToBody?.includes(theme);
				if (!preventAddClassToBody) {
					const bodyHasClassTheme = document
						.querySelector("body")
						.classList.contains(theme);
					const isCurrentPath = isCurrentPathPresent(
						themes[theme].allowedPagesToApplyThemes
					);
					const shouldAddClass = isCurrentPath && !bodyHasClassTheme;
					const shouldRemoveClass = !isCurrentPath && bodyHasClassTheme;

					if (shouldAddClass || shouldRemoveClass) {
						document.querySelector("body").classList.toggle(theme);
					}
				}
			}
		}
	}
};

export const extractThemeFromBodyClasses = (assetsCdn, brand) => {
	const theme = findThemeInClassesList(assetsCdn, brand);
	if (!theme && !bodyMutationObserver) {
		bodyMutationObserver = new MutationObserver(() => {
			findThemeInClassesList(assetsCdn, brand);
		});
		bodyMutationObserver.observe(document.body, { attributeFilter: ["class"] });
	}
};
